import { ElasticSearchUserResult } from 'interfaces/elasticSearchUserResult';
import tippy from 'tippy.js';

import Mention from '@tiptap/extension-mention';
import { ReactNodeViewRenderer, ReactRenderer } from '@tiptap/react';

import MentionNodeView from './Mention';
import MentionList from './MentionList';
import { mapUserObject } from './helpers';
import type { Mention as MentionType } from './helpers';

export const CustomMention = ({
  handleSearch,
  mentionableUsers,
}: {
  handleSearch: (search: string) => Promise<MentionType[]>;
  mentionableUsers: { edges: ElasticSearchUserResult[] };
}) =>
  Mention.extend({
    addNodeView() {
      return ReactNodeViewRenderer(MentionNodeView);
    },
  }).configure({
    deleteTriggerWithBackspace: true,
    suggestion: {
      char: '@',
      items: async ({ query }) => {
        let users = mapUserObject(mentionableUsers?.edges);

        const searchTerm = query?.toLowerCase?.() || '';

        if (searchTerm) {
          users = await handleSearch(searchTerm);
        }
        return users;
      },
      render: () => {
        let reactRenderer;
        let popup;

        return {
          onStart: (props) => {
            if (!props.clientRect) {
              return;
            }

            reactRenderer = new ReactRenderer(MentionList, {
              props,
              editor: props.editor,
            });

            // @ts-ignore
            popup = tippy('body', {
              getReferenceClientRect: props.clientRect,
              appendTo: () => document.body,
              onClickOutside: (instance) => {
                instance.hide();
              },
              content: reactRenderer.element,
              showOnCreate: true,
              interactive: true,
              trigger: 'manual',
              placement: 'auto-start',
            });
          },

          onUpdate(props) {
            reactRenderer.updateProps(props);

            if (!props.clientRect) {
              return;
            }

            popup[0].setProps({
              getReferenceClientRect: props.clientRect,
            });
          },

          onKeyDown(props) {
            if (props.event.key === 'Escape') {
              popup?.[0]?.hide();

              return true;
            }

            return reactRenderer.ref?.onKeyDown(props);
          },

          onExit() {
            popup?.[0]?.destroy();
            reactRenderer?.destroy();
          },
        };
      },
    },
    renderText({ options, node }) {
      return `${options.suggestion.char}[${node.attrs.label ?? node.attrs.id}](${node.attrs.id})`;
    },
  });

export default CustomMention;
